export default __webpack_public_path__ + "static/media/logout.9bda8835.svg";